import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface IListingRulesSectionProps {
    sections: IListingRulesSectionItemProps[];
}

export const ListingRulesSection = ({ sections }: IListingRulesSectionProps) => {
    const { t } = useTranslation();
    return <Stack direction={'column'}>
        <Typography variant={'h3'}>{t('listing.rules.guestsRulesTitle')}</Typography>
        <Stack direction={{ xs: 'column', md: 'row' }} justifyContent={'space-between'} gap={3}>
            {sections.map((section, index) => <ListingRulesSectionItem key={`rules-section-${index}`} {...section} />)}
        </Stack>
    </Stack>;
}

export interface IListingRulesSectionItemProps {
    /** The title of the rules' section */
    title: string;
    /** The list of rules in that section */
    items: IListingRulesItemProps[];
}
const ListingRulesSectionItem = ({ title, items }: IListingRulesSectionItemProps) => {
    return <Stack direction={'column'}>
        <Typography variant='h4'>{title}</Typography>
        {items.map((item, index) => <ListingRulesItem key={`${title}-item-${index}`} {...item} />)}
    </Stack>
}

export interface IListingRulesItemProps {
    /** (Optional) Icon to display */
    icon?: string;
    /** The rule's text */
    text: string;
}
const ListingRulesItem = ({ icon, text }: IListingRulesItemProps) => {
    return <Stack direction={'row'}>
        <Typography variant='body1'>{text}</Typography>
    </Stack>
}